import { createAction } from '@reduxjs/toolkit';

import { SagaPayload } from '../api.types';
import {
  DownloadDashboardResultsRequest,
  DownloadDashboardResultsResponse,
  RetrieveDashboardDetailRequest,
  RetrieveDashboardDetailResponse,
  RetrieveDashboardStructureRequest,
  RetrieveDashboardStructureResponse
} from './tracked-session-dashboard.types';

export const requestRetrieveDashboardDetail = createAction<
  SagaPayload<RetrieveDashboardDetailRequest, RetrieveDashboardDetailResponse['data']>['payload']
>('request/retrieveDashboardDetail');

export const requestRetrieveDashboardStructure = createAction<
  SagaPayload<RetrieveDashboardStructureRequest, RetrieveDashboardStructureResponse['data']>['payload']
>('request/retrieveDashboardStructure');

export const requestDownloadDashboardResults = createAction<
  SagaPayload<DownloadDashboardResultsRequest, DownloadDashboardResultsResponse['data']>['payload']
>('request/downloadDashboardResults');
